/* eslint-disable no-prototype-builtins */
import { requestAnyGet, requestDelete, requestGet, requestPost, requestPut } from '@configs';
import { showLoading } from '@store/actions';
import { getUserToken } from '@utils';
import { notification } from 'antd';
import {
  CREATE_ANSWER_QUIZ_BANK_SOAL,
  CREATE_QUIZ_BANK_SOAL,
  DELETE_QUIZ,
  GET_COURSE_BANK_SOAL,
  GET_EXAM_DETAIL,
  GET_EXAM_DETAIL_AND_QUESTION,
  GET_LIST_BANK_SOAL,
  GET_LIST_EXAM,
  GET_LIST_MASTER_SOAL,
  GET_QUESTION_BY_EXAM_ID,
  GET_QUESTION_BY_EXAM_ID_NEW,
  GET_QUIZ_DETAIL,
  GET_QUIZ_JAWABAN,
  GET_QUIZ_PERSONAL,
  GET_QUIZ_SOAL,
  GET_SOAL_BANK_SOAL,
  GET_TYPE_LIST,
  IS_SUCCESS,
  UPDATE_QUIZ,
} from '@type';
import axios from 'axios';
import { BASE_EXAM, BASE_EXAM_QUIZ } from '../../../../constants/initHttp';
import httpService from '../../../../configs/service';
import { getQuestionUjianByGuru } from '../Ujian.Guru';
import { normalizeDataQuestion } from '../../../selector/MediaKelas/UjianGuru';
import { allQuestionsValid } from './examQuestionValidation';
import { isValidExamId } from './examIdGuard';
import { notificationOverride, reportSentry } from '../../../../utils/Utils';
import { RESPONSE_ERRORS } from '../../../../constants/initError';

export const getQuizPersonal = (classId) => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    const rest = await requestGet('me/quiz', { quiz_type: 'SEKOLAH', class_id: classId }, getUserToken());

    dispatch({ type: GET_QUIZ_PERSONAL, value: rest.data });
  } catch (error) {
    // notification.error({
    //   message: 'Mohon Maaf!',
    //   description: 'Silahkan Hubungi Customer Service Kami',
    // });
  }
  dispatch(showLoading(false));
};

export const getListBankSoal = (keywords) => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    const rest = await requestAnyGet('https://api.siswamedia.com/g2j/', {
      id: '1VTedfoSXmis0lOoubDAA0kGG2pSNtT73fB9CGjQsQaU',
      sheet: 2,
      columns: false,
      q: keywords,
    });
    dispatch({ type: GET_LIST_BANK_SOAL, value: rest.rows });
  } catch (error) {
    notification.error({
      message: 'Mohon Maaf!',
      description: 'Silahkan Hubungi Customer Service Kami google sheet',
    });
  }
  dispatch(showLoading(false));
};

export const getListMasterSoal = (keywords) => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    const rest = await requestAnyGet('https://api.siswamedia.com/g2j/', {
      id: '1GU89LkfJXwiVDSVcMk7tZ4-VexIQIVISQknxfDS_FNY',
      sheet: 7,
      columns: false,
      q: keywords,
    });

    dispatch({ type: GET_LIST_MASTER_SOAL, value: rest.rows[0] });
  } catch (error) {
    notification.error({
      message: 'Mohon Maaf!',
      description: 'Silahkan Hubungi Customer Service Kami google sheet',
    });
  }
  dispatch(showLoading(false));
};

export const createQuizBankSoal = (body, key, total) => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    const rest = await requestPost('quiz', body, getUserToken());

    dispatch({
      type: CREATE_QUIZ_BANK_SOAL,
      value: { id: rest.data.id, key: key + 1, total },
    });
  } catch (error) {
    // notification.error({
    //   message: 'Mohon Maaf!',
    //   description: 'Silahkan Hubungi Customer Service Kami.',
    // });
  }
  dispatch(showLoading(false));
};

export const createAnswerQuizBankSoal = (objQuiz, body) => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    await requestPost(`quiz/${objQuiz.id}/bank-soal`, { kumpulan_soal: body }, getUserToken());

    if (objQuiz.key === objQuiz.total) {
      dispatch({ type: CREATE_ANSWER_QUIZ_BANK_SOAL, value: true });
    }
  } catch (error) {
    // notification.error({
    //   message: 'Mohon Maaf!',
    //   description: 'Silahkan Hubungi Customer Service Kami.',
    // });
  }
  dispatch(showLoading(false));
};

export const getSoalBankSoal = (linkSoal) => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    const rest = await requestAnyGet(linkSoal);

    dispatch({ type: GET_SOAL_BANK_SOAL, value: rest.rows });
  } catch (error) {
    notification.error({
      message: 'Mohon Maaf!',
      description: 'Silahkan Hubungi Customer Service Kami google sheet',
    });
  }
  dispatch(showLoading(false));
};

export const getCourseBankSoal = (classId, is_teacher = true) => {
  const api = async (dispatch) => {
    dispatch(showLoading(true));
    try {
      const rest = await requestGet(
        `classes/${classId}/courses`,
        {
          sortby: 'id',
          order: 'desc',
          limit: 10,
          page: 1,
          isteacher: is_teacher ?? false,
        },
        getUserToken()
      );

      dispatch({ type: GET_COURSE_BANK_SOAL, value: rest.data });
    } catch (error) {
      // notification.error({
      //   message: 'Mohon Maaf!',
      //   description: 'Silahkan Hubungi Customer Service Kami',
      // });
    }
    dispatch(showLoading(false));
  };
  return api;
};

export const updateQuiz = (quizId, body) => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    await requestPut(`quiz/${quizId}`, null, body, getUserToken());

    dispatch({ type: UPDATE_QUIZ, value: true });
  } catch (error) {
    // notification.error({
    //   message: 'Mohon Maaf!',
    //   description: 'Silahkan Hubungi Customer Service Kami',
    // });
  }
  dispatch(showLoading(false));
};

export const deleteQuiz = (quizId) => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    await requestDelete(`quiz/${quizId}`, null, getUserToken());

    dispatch({ type: DELETE_QUIZ, value: true });
  } catch (error) {
    // notification.error({
    //   message: 'Mohon Maaf!',
    //   description: 'Silahkan Hubungi Customer Service Kami',
    // });
  }
  dispatch(showLoading(false));
};

// Ujian Student
export const getQuizDetail = (quizId) => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    const rest = await requestGet(`quiz/${quizId}`, null, getUserToken());

    dispatch({ type: GET_QUIZ_DETAIL, value: rest.data });
  } catch (error) {
    // notification.error({
    //   message: 'Mohon Maaf!',
    //   description: 'Silahkan Hubungi Customer Service Kami',
    // });
  }
  dispatch(showLoading(false));
};

export const getQuizSoal = (quizId) => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    const rest = await requestGet(
      `quiz/${quizId}/bank-soal`,
      {
        order: 'asc',
      },
      getUserToken()
    );
    dispatch({ type: GET_QUIZ_SOAL, value: rest.data });
  } catch (error) {
    // notification.error({
    //   message: 'Mohon Maaf!',
    //   description: 'Silahkan Hubungi Customer Service Kami',
    // });
  }
  dispatch(showLoading(false));
};

export const getQuizJawaban = (quizId, userId) => (dispatch) => {
  dispatch(showLoading(true));
  return requestGet(`quiz/${quizId}/review-jawaban?user_id=${userId}`, null, getUserToken()).then(
    (res) => {
      dispatch({ type: GET_QUIZ_JAWABAN, value: res.data });
      dispatch(showLoading(false));
      return res.data;
    },
    (error) => {
      // notification.error({
      //   message: 'Mohon Maaf!',
      //   description: 'Silahkan Hubungi Customer Service Kami',
      // });
      dispatch(showLoading(false));
      throw error.response?.data || 'no_message';
    }
  );
};

export const submitQuiz = (data) => (dispatch) => {
  dispatch(showLoading(true));
  return requestPost('bank-soal/myanswer', data, getUserToken()).then(
    () => {
      notification.success({
        message: 'Sukses!',
        description: 'Berhasil mengumpulkan jawaban ujian',
      });
      dispatch(showLoading(false));
      return true;
    },
    () => {
      // notification.error({
      //   message: 'Mohon Maaf!',
      //   description: 'Silahkan Hubungi Customer Service Kami',
      // });
      dispatch(showLoading(false));
    }
  );
};

export const submitPenilaian = (data) => (dispatch) => {
  dispatch(showLoading(true));
  return requestPost('bank-soal/answer/score', data, getUserToken()).then(
    () => {
      notification.success({
        message: 'Sukses!',
        description: 'Berhasil membuat penilaian ujian',
      });
      dispatch(showLoading(false));
      return true;
    },
    (error) => {
      // notification.error({
      //   message: 'Mohon Maaf!',
      //   description: 'Silahkan Hubungi Customer Service Kami',
      // });
      dispatch(showLoading(false));
      throw error.response?.data || 'no_message';
    }
  );
};

export const createQuizExcel = (dataQuiz, dataSoal) => async (dispatch) => {
  // dispatch(showLoading(true));
  const api = await requestPost('quiz', dataQuiz, getUserToken())
    .then((response) => {
      if (response.status_code === 200) {
        dispatch(addQuizTemplate(response.data.id, dataSoal));
      }
    })
    .catch((error) => {
      const msgBackend = error.response.data.message;

      notification.error({
        message: 'Mohon Maaf!',
        description: RESPONSE_ERRORS.hasOwnProperty(msgBackend) ? RESPONSE_ERRORS[msgBackend] : 'Ada Kesalahan',
      });
      reportSentry(error);
    });
  return api;
};

export const addQuizTemplate = (id, dataSoal) => async (dispatch) => {
  dispatch(showLoading(true));
  const api = await requestPost(`quiz/${id}/bank-soal-template`, dataSoal, getUserToken())
    .then((response) => {
      if (response.status_code === 200) {
        dispatch({
          type: IS_SUCCESS,
          value: true,
          message: 'Add Quiz Success',
        });
        dispatch(showLoading(false));
      } else {
        dispatch({
          type: IS_SUCCESS,
          value: false,
          message: 'Add Quiz Failed',
        });
        dispatch(showLoading(false));
      }
    })
    .catch((error) => {
      const msgBackend = error.response.data.message;

      notification.error({
        message: 'Mohon Maaf!',
        description: msgBackend || 'Ada Kesalahan',
      });
      dispatch({
        type: IS_SUCCESS,
        value: false,
        message: 'Add Quiz Failed',
      });
      dispatch(showLoading(false));
      reportSentry(error);
    });
  return api;
};

// for ujian refactor
export const getTypeList = (page, limit) => async (dispatch) => {
  const api = await axios
    .get(`${BASE_EXAM}examtype?page=${page}&limit=${limit}&sort=id&direction=ASC`, {
      headers: { Authorization: `Bearer ${getUserToken()}` },
    })
    .then((response) => {
      dispatch({ type: GET_TYPE_LIST, value: response.data.payload });
    })
    .catch((error) => {
      reportSentry(error);
    });
  return api;
};
export const getListExam = (page, limit, class_id, status) => async (dispatch) => {
  const api = await axios
    .get(`${BASE_EXAM}exam?page=${page}&limit=${limit}&sort=id&direction=DESC&class_id=${class_id}&status=${status}`, {
      headers: { Authorization: `Bearer ${getUserToken()}` },
    })
    .then((response) => {
      dispatch({
        type: GET_LIST_EXAM,
        value: response.data?.payload?.list,
      });
    })
    .catch((error) => {
      reportSentry(error);
    });
  return api;
};

export const addUjian = (data) => async (dispatch) => {
  dispatch(showLoading(true));
  const api = await axios
    .post(`${BASE_EXAM}exam`, data, {
      headers: { Authorization: `Bearer ${getUserToken()}` },
    })
    .then((response) => {
      dispatch(showLoading(false));
      if (response.data.statusCode === 200) {
        return response.data;
      }
    })
    .catch((error) => {
      dispatch(showLoading(false));
      const msg = error?.response?.data?.message;
      if (msg === 'invalid_curriculum_component_description') {
        notificationOverride({
          type: 'error',
          description: 'Mohon maaf TP (Kurmer) /KD (2013) atau Elemen (Kurmer) /KI (2013) yang dipilih sudah terhapus.',
        });
        return;
      }

      /* ------------------------- minute duration getter ------------------------- */
      const date1 = new Date(data?.start_date);
      const date2 = new Date(data?.end_date);
      const diffInMs = Math.abs(date2 - date1);
      const convertMinutes = diffInMs / (1000 * 60);

      if (convertMinutes < data?.duration) {
        /* ------- message show if duration greater than end_date - start date ------ */
        notification.error({
          message: 'Mohon Maaf!',
          description: 'Durasi yang anda berikan melebihi waktu akhir',
        });
      } else {
        /* ----------------------------- general message ---------------------------- */
        notification.error({
          message: 'Mohon Maaf!',
          description: 'Ada Kesalahan',
        });
      }
      reportSentry(error);
    });

  return api;
};

// BNS-3167 Task 2: the bulk bridge answers duplicate target races (subject or
// class deleted / archived between preflight and create) with an HTTP 400
// standard response carrying `error` instead of `message`. Each code maps to
// its exact copy; the thunk shows the mapped message and resolves a non-ok
// preflight failure so BuatUjian keeps the duplicate modal/form selection and
// never redirects or retries created targets.
const DUPLICATE_RACE_ERROR_MESSAGES = {
  course_id_not_found:
    'Mohon maaf mata pelajaran yang Anda pilih tidak dapat ditambahkan karena data mata pelajaran telah dihapus',
  class_inactive:
    'Mohon maaf kelas yang Anda pilih tidak dapat ditambahkan karena data kelas tersebut telah diarsipkan',
  class_deleted: 'Mohon maaf kelas yang Anda pilih tidak dapat ditambahkan karena data kelas tersebut telah dihapus',
};

// BNS-3167: create the same exam across multiple parallel classes in one call.
// POST ${BASE_EXAM}exam/bulk accepts the normal exam payload where `courses` is a
// list of target courses plus `publish_status` (DRAFT/PUBLISHED) and answers in
// the bridge shape { created: [{ course_id, school_exam }], failed: [] }.
//
// Result contract (consumed by BuatUjian.handleDuplicateSubmit):
//   { ok, partial, created, failed, requested, createdCount, reason? }
//
// BNS-3167 Task 4: full success requires a STRUCTURALLY VALID backend response —
// `created` AND `failed` must both be arrays; `failed` must be empty; every
// created entry must be a non-null object with a positive `course_id`; and the
// created course ids must exactly and uniquely equal the requested positive
// course ids (order-insensitive — not merely the same count). A body that
// explicitly carries a non-200 statusCode is never success either (an absent
// statusCode stays permitted for flat/legacy payloads). Anything else resolves
// as ok:false with a reason, so BuatUjian never redirects. Zero/short/
// malformed/invalid created responses are never treated as success and the
// requested count is never substituted for created.
//
// createdCount is the number of unique, structurally valid created entries whose
// course_id is among the requested positive ids — the count feedback must use.
// Raw `created`/`failed` are retained as diagnostics and may include malformed
// entries.
export const addUjianBulk = (data) => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    const response = await axios.post(`${BASE_EXAM}exam/bulk`, data, {
      headers: { Authorization: `Bearer ${getUserToken()}` },
    });
    const body = response?.data;
    // BNS-3167 Task 4: an explicit non-200 statusCode in the response body is a
    // hard failure even when the payload looks like a full success. An absent
    // statusCode stays permitted for flat/legacy bridge responses.
    const bodyStatusInvalid =
      body && typeof body === 'object' && body.statusCode !== undefined && Number(body.statusCode) !== 200;
    const payload =
      body && typeof body === 'object' && body.payload && typeof body.payload === 'object' ? body.payload : body;
    const createdRaw = payload?.created;
    const failedRaw = payload?.failed;
    const requestedCourses = Array.isArray(data?.courses) ? data.courses : [];
    const requested = requestedCourses.length;
    const requestedIds = requestedCourses
      .map((course) => (course ? course.course_id : undefined))
      .filter((id) => typeof id === 'number' && Number.isFinite(id) && id > 0);
    dispatch(showLoading(false));

    // Structural validity (BNS-3167 Task 4): `created` and `failed` must both be
    // arrays; every created entry must be a non-null object with a positive
    // course_id; and the created course ids must exactly and uniquely equal the
    // requested positive ids — order-insensitive — with no failures. The
    // requested id list itself must be positive and unique before created
    // results are validated, so a duplicated requested course id can never
    // rescue a full success.
    const createdIsArray = Array.isArray(createdRaw);
    const failedIsArray = Array.isArray(failedRaw);
    const created = createdIsArray ? createdRaw : [];
    const failed = failedIsArray ? failedRaw : [];
    const isValidCreatedEntry = (entry) =>
      entry !== null &&
      typeof entry === 'object' &&
      !Array.isArray(entry) &&
      typeof entry.course_id === 'number' &&
      Number.isFinite(entry.course_id) &&
      entry.course_id > 0;
    const createdEntriesAllValid = created.length > 0 && created.every(isValidCreatedEntry);
    const createdIds = createdEntriesAllValid ? created.map((entry) => entry.course_id) : [];

    // BNS-3167 Task 4: feedback counts only unique, structurally valid created
    // entries whose course_id is among the requested positive ids — never the
    // raw created.length (malformed/partial entries must not inflate the
    // "berhasil" count), and partial is derived from that same count (> 0) —
    // not from any structurally valid raw entry (requested [1,2] with created
    // [5,6] must surface as a plain failure, never a partial). Raw
    // created/failed stay in the result as diagnostics.
    const seenCreatedIds = new Set();
    const createdCount = created.reduce((count, entry) => {
      if (
        !isValidCreatedEntry(entry) ||
        !requestedIds.includes(entry.course_id) ||
        seenCreatedIds.has(entry.course_id)
      ) {
        return count;
      }
      seenCreatedIds.add(entry.course_id);
      return count + 1;
    }, 0);

    const requestedListPositiveAndUnique =
      requested > 0 && requestedIds.length === requested && new Set(requestedIds).size === requestedIds.length;
    const idsMatchExactly =
      requestedListPositiveAndUnique &&
      createdIds.length === requested &&
      new Set(createdIds).size === createdIds.length &&
      requestedIds.every((id) => createdIds.includes(id));

    const isFullSuccess =
      createdIsArray && failedIsArray && failed.length === 0 && idsMatchExactly && !bodyStatusInvalid;

    if (bodyStatusInvalid) {
      return { ok: false, partial: false, created, failed, requested, createdCount: 0, reason: 'invalid_status' };
    }
    if (isFullSuccess) {
      return { ok: true, partial: false, created, failed, requested, createdCount };
    }

    // Not a full success: partial only when at least one of the REQUESTED
    // courses was actually created (createdCount > 0), plain failure otherwise.
    // reason lets the caller message each case.
    let reason = 'malformed_created';
    if (createdIsArray && failedIsArray) {
      if (created.length === 0) {
        reason = 'zero_created';
      } else if (created.length < requested) {
        reason = 'short_created';
      } else if (created.length > requested) {
        reason = 'malformed_created';
      } else if (failed.length > 0) {
        reason = 'partial_failure';
      } else if (!createdEntriesAllValid || !idsMatchExactly) {
        reason = 'invalid_created';
      }
    }
    return {
      ok: false,
      partial: createdCount > 0,
      created,
      failed,
      requested,
      createdCount,
      reason,
    };
  } catch (error) {
    dispatch(showLoading(false));
    // BNS-3167 Task 2: normalize the HTTP 400 standard response — the bridge
    // answers races with `error`, preferring it over a (possibly empty)
    // `message` like the journal API flow. Each race code surfaces its exact
    // copy and resolves non-ok with the code, so getBulkSubmitFeedback returns
    // null and BuatUjian keeps the duplicate modal/form selection, never
    // redirecting or retrying created targets (the bulk was rejected preflight).
    const errorData = error?.response?.data;
    const msg = errorData?.error || errorData?.message;
    if (DUPLICATE_RACE_ERROR_MESSAGES.hasOwnProperty(msg)) {
      notificationOverride({
        type: 'error',
        description: DUPLICATE_RACE_ERROR_MESSAGES[msg],
      });
      return { ok: false, code: msg };
    }
    if (msg === 'invalid_curriculum_component_description') {
      notificationOverride({
        type: 'error',
        description: 'Mohon maaf TP (Kurmer) /KD (2013) atau Elemen (Kurmer) /KI (2013) yang dipilih sudah terhapus.',
      });
      return { ok: false, code: msg };
    }

    /* ------------------------- minute duration getter ------------------------- */
    const date1 = new Date(data?.start_date);
    const date2 = new Date(data?.end_date);
    const diffInMs = Math.abs(date2 - date1);
    const convertMinutes = diffInMs / (1000 * 60);

    if (convertMinutes < data?.duration) {
      /* ------- message show if duration greater than end_date - start date ------ */
      notification.error({
        message: 'Mohon Maaf!',
        description: 'Durasi yang anda berikan melebihi waktu akhir',
      });
    } else {
      /* ----------------------------- general message ---------------------------- */
      notification.error({
        message: 'Mohon Maaf!',
        description: 'Ada Kesalahan',
      });
    }
    reportSentry(error);
    return { ok: false, code: msg || '' };
  }
};

export const getExamDetail = (id) => async (dispatch) => {
  const api = await axios
    .get(`${BASE_EXAM}exam/${id}`, {
      headers: { Authorization: `Bearer ${getUserToken()}` },
    })
    .then((response) => {
      dispatch({ type: GET_EXAM_DETAIL, value: response.data?.payload });
    })
    .catch((error) => {
      reportSentry(error);
    });
  return api;
};
export const getQuestionByExamID = (page, id) => async (dispatch) => {
  if (!isValidExamId(id)) {
    return undefined;
  }
  const api = await axios
    .get(`${BASE_EXAM_QUIZ}question?exam_id=${id}&page=${page}&item_per_page=10`, {
      headers: { Authorization: `Bearer ${getUserToken()}` },
    })
    .then((response) => {
      dispatch({
        type: GET_QUESTION_BY_EXAM_ID,
        value: response.data?.data,
      });
    })
    .catch((error) => {
      reportSentry(error);
    });
  return api;
};

export const getQuestionUjianByGuruNew = (params) => async (dispatch) => {
  if (!isValidExamId(params?.exam_id)) {
    return undefined;
  }
  dispatch(showLoading(true));
  return httpService
    .get('question', { baseURL: BASE_EXAM_QUIZ, params })
    .then((response) => {
      dispatch({
        type: GET_QUESTION_BY_EXAM_ID_NEW,
        value: response.data?.data,
      });
    })
    .catch(() => {
      // notification.error({
      //   message: 'Mohon Maaf!',
      //   description: 'Silahkan Hubungi Customer Service Kami',
      // });
    })
    .finally(() => {
      dispatch(showLoading(false));
    });
};

export const editUjian = (id, data) => async (dispatch) => {
  dispatch(showLoading(true));
  const api = await axios
    .put(`${BASE_EXAM}exam/${id}`, data, {
      headers: { Authorization: `Bearer ${getUserToken()}` },
    })
    .then((response) => {
      dispatch(showLoading(false));
      if (response.data.statusCode === 200) {
        return response.data;
      }
    })
    .catch((error) => {
      dispatch(showLoading(false));
      const msg = error?.response?.data?.message;
      if (msg === 'invalid_curriculum_component_description') {
        notificationOverride({
          type: 'error',
          description: 'Mohon maaf TP (Kurmer) /KD (2013) atau Elemen (Kurmer) /KI (2013) yang dipilih sudah terhapus.',
        });
        return;
      }
      notification.error({
        message: 'Mohon Maaf!',
        description: 'Ada Kesalahan',
      });
      reportSentry(error);
      return false;
    });

  return api;
};
export const editCourses = (id, data) => async (dispatch) => {
  dispatch(showLoading(true));
  const api = await axios
    .put(`${BASE_EXAM}course/update/${id}`, data, {
      headers: { Authorization: `Bearer ${getUserToken()}` },
    })
    .then((response) => {
      dispatch(showLoading(false));
      if (response.data.statusCode === 200) {
        return response.data;
      }
    })
    .catch((error) => {
      dispatch(showLoading(false));

      notification.error({
        message: 'Mohon Maaf!',
        description: 'Ada Kesalahan',
      });
      throw error;
    });

  return api;
};

export const getCurriculumReselection = (examId, courseId) => async () => {
  const response = await axios.get(`${BASE_EXAM}exam/${examId}/curriculum-reselection`, {
    params: { course_id: courseId },
    headers: { Authorization: `Bearer ${getUserToken()}` },
  });

  return response.data.payload;
};
export const deleteUjian = (id) => async (dispatch) => {
  dispatch(showLoading(true));
  const api = await axios
    .delete(`${BASE_EXAM}exam/${id}`, {
      headers: { Authorization: `Bearer ${getUserToken()}` },
    })
    .then((response) => {
      dispatch(showLoading(false));
      if (response.data.statusCode === 200) {
        return response.data;
      }
    })
    .catch((error) => {
      dispatch(showLoading(false));

      notification.error({
        message: 'Mohon Maaf!',
        description: 'Ada Kesalahan',
      });
      reportSentry(error);
    });

  return api;
};

export const getExamDetailandQuestion = (id, exam_id) => async (dispatch) => {
  // BNS-3167 Task 5: resolve with the hydrated detail on success so the list
  // page can navigate only after a real load, and resolve false (never throw)
  // on any failure so a broken fetch can never redirect the user. The existing
  // EditUjian consumer only relies on the GET_EXAM_DETAIL_AND_QUESTION dispatch,
  // which is preserved.
  //
  // Spec-review (Task 5 gaps):
  // - A failed or invalid question request must never dispatch the success
  //   action or resolve truthy. getQuestionUjianByGuru swallows its own request
  //   errors into undefined, so an empty-array fallback used to mask a
  //   questions failure and let the duplicate flow navigate with zero
  //   questions. Only a real array result is treated as a successful load.
  // - An explicit non-200 statusCode in the response body is a hard failure
  //   EVEN when a payload rides along (mirrors addUjianBulk); an absent
  //   statusCode stays permitted for flat/legacy payloads.
  // - Every question entry must carry the required create identifiers
  //   (qbank_quiz_id / qbank_question_id / qbank_group_id / qbank_point /
  //   qbank_question_type). A single malformed entry rejects the whole load:
  //   no dispatch, no navigation, no silent partial duplication.
  // - Final re-review: qbank_group_id must be EXPLICITLY present (an ungrouped
  //   question is encoded as `null`, so a missing key or `undefined` value is
  //   just as malformed as any other missing identifier).
  // - Re-review: the detail payload is additionally gated BEFORE any question
  //   fetch / success dispatch / return. Only a plain object carrying a
  //   positive id that EXACTLY matches the requested exam id may proceed — an
  //   array payload, a missing/non-positive id, or the id of a different exam
  //   fails the load with no side effect, so the duplicate flow can never
  //   prefill (or a deep-link refetch hydrate) from a wrong or partial detail.
  //   The id is required non-null on the payload; qbank_group_id MAY be null
  //   on a question entry (ungrouped questions are a legal create shape) but
  //   must still be present — null is the only legal "no group" value, see
  //   examQuestionValidation.js.
  try {
    const response = await axios.get(`${BASE_EXAM}exam/${id}`, {
      headers: { Authorization: `Bearer ${getUserToken()}` },
    });
    const body = response && response.data ? response.data : null;

    if (body && typeof body === 'object' && body.statusCode !== undefined && Number(body.statusCode) !== 200) {
      return false;
    }

    let tempRes = body && body.payload ? body.payload : {};

    // Re-review id gate: reject array payloads outright, then require a
    // positive id exactly matching the requested exam id (missing id, 0 /
    // negative / non-number id, and a different exam's id all fail the load
    // here — before the question fetch, the success dispatch and the truthy
    // return that the list page navigates on).
    if (!tempRes || typeof tempRes !== 'object' || Array.isArray(tempRes)) {
      return false;
    }
    const payloadId = tempRes.id;
    const payloadIdIsPositive = typeof payloadId === 'number' && Number.isFinite(payloadId) && payloadId > 0;
    if (!payloadIdIsPositive || payloadId !== id) {
      return false;
    }

    const tempCourses = [];
    tempRes.courses &&
      tempRes.courses.forEach((val) => {
        if (!tempCourses.includes(val.course_id)) {
          tempCourses.push(val.course_id);
        }
      });
    const tempQuestion = await dispatch(getQuestionUjianByGuru({ exam_id }));
    if (!Array.isArray(tempQuestion)) {
      return false;
    }
    const normalizedQuestions = normalizeDataQuestion(tempQuestion);
    if (!allQuestionsValid(normalizedQuestions)) {
      return false;
    }
    tempRes = {
      ...tempRes,
      questions: normalizedQuestions,
      courses: tempCourses || [],
    };

    dispatch({ type: GET_EXAM_DETAIL_AND_QUESTION, value: tempRes });
    return tempRes;
  } catch (error) {
    reportSentry(error);
    return false;
  }
};
export const getSchoolYearExam = (params) => async (dispatch) => {
  dispatch(showLoading(true));
  return httpService
    .get('schoolyear', { baseURL: BASE_EXAM, params })
    .then((response) => (response.data.payload ? response.data.payload.list : []))
    .catch((err) => {
      console.log('err', err);
      return null;
    })
    .finally(() => {
      dispatch(showLoading(false));
    });
};

export const exportPDF = (params, filename = 'file') => {
  const api = async (dispatch) => {
    dispatch(showLoading(true));
    return httpService
      .get('export/exam/pdf', {
        baseURL: `${BASE_EXAM}`,
        params,
        responseType: 'blob',
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}.pdf`);
        document.body.appendChild(link);
        link.click();
      })
      .catch(() => {
        // notification.error({
        //   message: 'Mohon Maaf!',
        //   description: 'Silahkan Hubungi Customer Service Kami',
        // });
      })
      .finally(() => {
        dispatch(showLoading(false));
      });
  };
  return api;
};

/*
 * `examDetailNew` is a cache, not a live view: EditUjian hydrates the form from
 * it on mount. A second visit to the same exam therefore re-rendered the form
 * straight from the previous fetch, which also meant its loading skeleton never
 * appeared. The edit page clears the entry before every fetch, so each visit
 * loads and shows the loading state instead of hydrating from stale data.
 */
export const clearExamDetail = () => ({
  type: GET_EXAM_DETAIL_AND_QUESTION,
  value: null,
});

export const clearCourseBankSoal = () => ({
  type: GET_COURSE_BANK_SOAL,
  value: false,
});

export const clearQuizPersonal = () => ({
  type: GET_QUIZ_PERSONAL,
  value: false,
});

export const clearListBankSoal = () => ({
  type: GET_LIST_BANK_SOAL,
  value: false,
});

export const clearUpdateQuiz = () => ({
  type: UPDATE_QUIZ,
  value: false,
});

export const clearDeleteQuiz = () => ({
  type: DELETE_QUIZ,
  value: false,
});

export const clearAnswerCreateQuiz = () => ({
  type: CREATE_ANSWER_QUIZ_BANK_SOAL,
  value: false,
});
